import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IChat } from '../../pages/chat/type';
import { IChatState, IStatus, IIncomingRoom, IOutgoingRoom, IActiveRoom, IAction, IMessage, IRigthPanel, IInteractionModal, IInteractionHistory, IEFormModal, IEFormData, IChatConfiguration } from "./types";

const addMessage = (state: IChatState, action: PayloadAction<IMessage[]>) => {
    action.payload.forEach(msg => {
        if (state.messages.find(a => a.messageId == msg.messageId) == undefined)
            state.messages.push(msg);
    });
}

const removeExistingChatRoom = (state: IChatState, action: PayloadAction<IIncomingRoom[]>) => {
    state.incomingRoom.forEach((i, idx) => {
        if (action.payload.find((a) => a.roomId == i.roomId)) state.incomingRoom.splice(idx);
    })
}
const removeExistingQueueChatRoom = (state: IChatState, action: PayloadAction<IIncomingRoom[]>) => {
    state.incomingQueueRoom.forEach((i, idx) => {
        if (action.payload.find((a) => a.sessionId == i.sessionId)) {
            state.incomingQueueRoom.splice(idx);
        }
    });
}
const addNotification = (state: IChatState, payload: IMessage[]) => {
    payload.forEach(msg => {
        if (state.notifications.find(a => a.messageId == msg.messageId) == undefined)
            state.notifications.push(msg);
    });
}
const updateLatestMessage = (i: IIncomingRoom, action: IAction) => {
    const message = (action.payload.message as IMessage[])[0];
    if (message && i.roomId == message.roomId) {
        i.latestMessage = message.messageType == "TEXT"
            ? message.message : 'Send ' + message.messageType.toLocaleLowerCase();
        i.latestSender = message.senderName;
        i.latestMessageTime = message.messageTime;
    }
    return i;
}
const updateIncomingRoom = (state: IChatState, action: PayloadAction<IStatus>) => {
    if (action.payload.status == "RESOLVED") {
        state.incomingRoom = state.incomingRoom.filter(i => i.sessionId != action.payload.sessionId);
    } else if (action.payload.status == "UNASSIGNED") {
        state.incomingRoom = state.incomingRoom.filter(i => i.sessionId != action.payload.sessionId);
    } else if (action.payload.status == "SENT") {
        state.incomingRoom = state.incomingRoom.map(i => updateLatestMessage(i, action));
        state.incomingQueueRoom = state.incomingQueueRoom.map(i => updateLatestMessage(i, action));
    }
    else if (action.payload.status == "ONLINE" || action.payload.status == "OFFLINE") {
        state.incomingRoom = state.incomingRoom.map(i => {
            if (i.account == action.payload.userName) i.status = action.payload.status.toLowerCase();
            return i;
        });
    }
}
const updateIncomingQueueRoom = (state: IChatState, action: PayloadAction<IStatus>) => {
    if (action.payload.status == "DEQUEUE") {
        state.incomingQueueRoom = state.incomingQueueRoom.filter(i => i.sessionId != action.payload.sessionId);
    }
}
const updateNotifications = (state: IChatState, action: PayloadAction<IMessage[]>) => {
    //set is sent flag     
    for (const msg of action.payload) {
        msg.isSent = true;
    }

    const incomingMessage = ([...action.payload] as IMessage[]);
    const unreadNotif = incomingMessage.filter(a => !a.messageRead && a.roomOwner);
    //update notif from newly chat
    if (unreadNotif) {
        addNotification(state, unreadNotif);
    }
    //remove previous clicked notification
    if (state.activeRoom) {
        state.notifications.forEach((item, idx) => {
            if (item.sessionId == state.activeRoom.sessionId) {
                console.log('deleted', item);
                const exist = incomingMessage.find(a => a.messageId == item.messageId && a.messageRead != item.messageRead);
                if (exist) state.notifications.splice(idx);
            }
        });
    }
}

const resetUnreadMessage = (state: IChatState, sessionId: string) => {
    state.incomingRoom.forEach(a => {
        if (sessionId == a.sessionId) a.unreadMessageCount = 0
    });
}
const updateUnreadMessage = (state: IChatState, action: PayloadAction<IMessage[]>) => {
    state.incomingRoom.forEach(a => {
        if (a.sessionId == action.payload[0]?.sessionId
            && action.payload[0]?.roomOwner) {
            a.unreadMessageCount = Number(a.unreadMessageCount) + 1;
        }
        if (a.sessionId == state.activeRoom?.sessionId)
            a.unreadMessageCount = 0;
    });
}
const chatSlice = createSlice({
    name: 'chat',
    initialState: {
        messages: [] as IMessage[],
        incomingRoom: [] as IIncomingRoom[],
        incomingQueueRoom: [] as IIncomingRoom[],
        outgoingRoom: [] as IOutgoingRoom[],
        status: ({} as any) as IStatus,
        activeRoom: ({} as any) as IActiveRoom,
        notifications: [] as IMessage[],
        rightPanel: ({} as any) as IRigthPanel,
        interactionModal: ({} as any) as IInteractionModal,
        eformModal: ({} as any) as IEFormModal,
        configuration: ({} as any) as IChatConfiguration,
        connected: false,
        scrollPosition: "bottom",
        allowReceiveChat: false,
    },
    reducers: {
        incomingChat: (state, action: PayloadAction<IMessage[]>) => {
            addMessage(state, action);
            updateNotifications(state, action);
            updateUnreadMessage(state, action);
        },
        incomingChatRoom: (state, action: PayloadAction<IIncomingRoom[]>) => {
            removeExistingChatRoom(state, action);
            state.incomingRoom = [...state.incomingRoom, ...action.payload];
        },
        outgoingChatRoom: (state, action: PayloadAction<IOutgoingRoom[]>) => {
            state.outgoingRoom = [...action.payload];
        },
        updateChatRoomOffset: (state, action: PayloadAction<{ sessionId: string; offset: number }>) => {
            const room = state.incomingRoom.find(a => a.sessionId == action.payload.sessionId);
            if (room) room.offset = action.payload.offset;
        },
        incomingQueueChatRoom: (state, action: PayloadAction<IIncomingRoom[]>) => {
            removeExistingQueueChatRoom(state, action);
            state.incomingQueueRoom = [...state.incomingQueueRoom, ...action.payload];
        },
        chatCallBack: (state, action: PayloadAction<IStatus>) => {
            updateIncomingRoom(state, action);
            updateIncomingQueueRoom(state, action);
            state.status = action.payload
        },
        setChatConfiguration: (state, action: PayloadAction<IChatConfiguration>) => {
            state.configuration = action.payload
        },
        clearChatCallBack: (state) => {
            state.status = {} as IStatus;
        },
        unreadNotification: (state, action: PayloadAction<IMessage[]>) => {
            addNotification(state, action.payload);
        },
        activeChatRoom: (state, action: PayloadAction<IActiveRoom>) => {
            resetUnreadMessage(state, action.payload.sessionId);
            state.activeRoom = action.payload;
        },
        connected: (state, action: PayloadAction<boolean>) => {
            state.connected = action.payload;
        },
        setScrollPosition: (state, action: PayloadAction<"bottom" | "stay">) => {
            state.scrollPosition = action.payload;
        },
        removeOfflineMessage: (state) => {
            state.messages = state.messages.filter(a => a.isSent);
        },
        resetChatState: (state) => {
            state.incomingRoom = [];
            state.rightPanel.visible = false;
            state.interactionModal.visible = false;
            state.activeRoom = {} as IActiveRoom;
            state.notifications = [];
            state.messages = [];
        },
        sendOfflineMessage: (state, action: PayloadAction<IChat>) => {
            const { sessionId, roomId, senderName, deviceId, content } = action.payload;
            const { files, message, type } = content;
            const newMessage = {
                message,
                messageFiles: files,
                messageId: 0,
                messageRead: false,
                messageType: type,
                roomId,
                sessionId,
                roomOwner: false,
                isSent: false,
                senderId: deviceId,
                senderName
            } as IMessage;
            state.messages = [...state.messages, newMessage];
        },
        updateSessionTag: (state, action: PayloadAction<{ sessionId: string; sessionTag: string }>) => {
            const room = state.incomingRoom.find(a => a.sessionId == action.payload.sessionId);
            if (room) room.tag = action.payload.sessionTag;
        },
        chatWSConnecting: (state) => {
            return;
        },
        chatWSDisconnecting: (state) => {
            return;
        },
        chatWSOffline: (state) => {
            return;
        },
        joinRoom: (state, action: PayloadAction<{ deviceId: string, userName: string }>) => {
            return;
        },
        dequeueChat: (state, action: PayloadAction<{ sessionId: string, userName: string }>) => {
            return;
        },
        assignChat: (state, action: PayloadAction<{ sessions: Array<string>, assignTo: string }>) => {
            return;
        },
        reassignChat: (state, action: PayloadAction<{ sessions: Array<string>, assignFrom: string, assignTo: string }>) => {
            return;
        },
        sendMessage: (state, action: PayloadAction<IChat>) => {
            return;
        },
        resolveRoom: (state, action: PayloadAction<{ roomId: string, tenantId: string, sessionId: string }>) => {
            return;
        },
        readMessage: (state, action: PayloadAction<{ sessionId: string | undefined, messageId: number }>) => {
            return;
        },
        typingMessage: (state, action: PayloadAction<{ sessionId: string, userName: string }>) => {
            return;
        },
        openRightPanel: (state, action: PayloadAction<{ body: "CUSTOMER_PROFILE" | "INTERACTION" | "INTERACTION_HISTORY" | "PRODUCT_SCRIPT" | "ADD_PHONE_NUMBER" | "CHAT_AND_PRODUCT_SCRIPT" }>) => {
            state.rightPanel.visible = true;
            state.rightPanel.body = action.payload.body;
        },
        closeRightPanel: (state) => {
            state.rightPanel.visible = false;
        },
        openInteractionModal: (state, action: PayloadAction<IInteractionHistory>) => {
            state.interactionModal.visible = true;
            state.interactionModal.data = action.payload;
        },
        closeInteractionModal: (state) => {
            state.interactionModal.visible = false;
        },
        openEFormModal: (state, action: PayloadAction<IEFormData>) => {
            state.eformModal.visible = true;
            state.eformModal.data = action.payload;
        },
        closeEFormModal: (state) => {
            state.eformModal.visible = false;
        },
        allowReceiveChat: (state, action: PayloadAction<boolean>) => {
            state.allowReceiveChat = action.payload;
        },



    },
});

export const {
    incomingChat,
    outgoingChatRoom,
    incomingChatRoom,
    incomingQueueChatRoom,
    chatCallBack,
    clearChatCallBack,
    unreadNotification,
    activeChatRoom,
    chatWSConnecting,
    joinRoom,
    dequeueChat,
    assignChat,
    reassignChat,
    sendMessage,
    resolveRoom,
    readMessage,
    typingMessage,
    openRightPanel,
    closeRightPanel,
    sendOfflineMessage,
    connected,
    setScrollPosition,
    removeOfflineMessage,
    openInteractionModal,
    closeInteractionModal,
    openEFormModal,
    closeEFormModal,
    resetChatState,
    chatWSDisconnecting,
    setChatConfiguration,
    updateSessionTag,
    chatWSOffline,
    allowReceiveChat,
    updateChatRoomOffset
} = chatSlice.actions
export default chatSlice.reducer

